export enum ProgramStatus {
  Future = 'FUTURE',
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}
